import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericAutocomplete from 'ui/DropdownItems/GenericAutocomplete';
import ResetWrapper from 'ui/DropdownItems/ResetWrapper';
import { AutocompletAble, ModalFormItem } from 'ui/DropdownItems/types';
import { InscriptionSource } from '../type';
import { camelize } from 'helpers/syntaxHelper';

type Props = {
    year: AutocompletAble<number> | null;
    setYear: DispatchState<AutocompletAble<number> | null>;
    availableYears: AutocompletAble<number>[];
    step: AutocompletAble<string>[] | null;
    setStep: DispatchState<AutocompletAble<string>[] | null>;
    availableSteps: AutocompletAble<string>[];
    phase: AutocompletAble<string> | null;
    setPhase: DispatchState<AutocompletAble<string> | null>;
    availablePhases: AutocompletAble<string>[];
    inscriptionSource: AutocompletAble<string> | null;
    currentStep: number;
};

export default function SecondStep({
    year,
    setYear,
    availableYears,
    step,
    setStep,
    availableSteps,
    phase,
    setPhase,
    availablePhases,
    inscriptionSource,
    currentStep,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const autocompletes: Array<ModalFormItem<number | string>> = [
        {
            children: (
                <GenericAutocomplete
                    selectedValues={year}
                    availableValues={availableYears}
                    setSelectedValues={setYear}
                    label={t('adminBudgetSpace.initInscriptions.exerciceRef')}
                    key="year"
                />
            ),
            value: year,
            setValue: setYear,
        },
        ...(inscriptionSource?.value == InscriptionSource.BudgetLineInscriptions
            ? [
                  {
                      children: (
                          <GenericAutocomplete
                              multiple
                              selectedValues={step}
                              availableValues={availableSteps}
                              setSelectedValues={setStep}
                              label={t(
                                  'adminBudgetSpace.initInscriptions.stepRef',
                              )}
                              shouldSortOptions
                              key="step"
                          />
                      ),
                      value: step,
                      setValue: setStep,
                  },
              ]
            : [
                  {
                      children: (
                          <GenericAutocomplete
                              selectedValues={phase}
                              availableValues={availablePhases}
                              setSelectedValues={setPhase}
                              label={t(
                                  'adminBudgetSpace.initInscriptions.phaseRef',
                              )}
                              key="phase"
                          />
                      ),
                      value: phase,
                      setValue: setPhase,
                  },
              ]),
    ];

    return (
        <>
            <Typography variant="h4" sx={{ paddingBottom: '1.5em' }}>
                {t('adminBudgetSpace.initInscriptions.title')}
            </Typography>
            <Typography variant="h5" sx={{ paddingBottom: '1.5em' }}>
                {t('adminBudgetSpace.initInscriptions.step', {
                    current: currentStep,
                })}
            </Typography>
            <Typography sx={{ whiteSpace: 'break-spaces' }}>
                {t(
                    `adminBudgetSpace.initInscriptions.secondStepText.${camelize(inscriptionSource?.value || '')}`,
                )}
            </Typography>
            <ResetWrapper items={autocompletes} />
        </>
    );
}
